import { downloadBlobFromResponse, getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "../../../../../../../utils/url/urlResolver";
import { userIsSalesman } from "~/domains/user/utils/roles";

export enum ReportType {
  CSV = "1",
  XLSX = "0",
}

export interface CartForm {
  orderType: string;
  totalPrice: number | null;
  currency: string;
  approxWeight: string;
  cartEntries: CartFormEntry[];
  reportLabels: Dict<string>;
}

export interface CartFormEntry {
  partNumber: string;
  matnr: string;
  description: string;
  quantity: number;
  packaging: string;
  shipment: string;
  customerMaterialNumber: string;
  requestedDeliveryDate: string;
  estimatedShippingDate: string;
  availability: string;
  netPrice: number | null;
  priceUnit: string;
  totalNetPrice: number | null;
  comment: string;
  priceReference: string;
  orderLineReference: string;
  customerOrderNumber: string;
  inCampaignScope: string | null;
}

export const downloadFile = (data: CartForm, type: ReportType): Promise<unknown> => {
  const isSalesman = userIsSalesman();
  const cartName = isSalesman ? "quote" : "cart";
  const url = resolveApiUrl(`/${cartName}/report/${type}`);

  return fetch(url, {
    body: JSON.stringify(data),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  }).then(downloadBlobFromResponse);
};

export const getReportLabels = (): string[] => {
  return [
    "cartPage.report.customer.number",
    "cartPage.report.order.type",
    "cartPage.report.total.price",
    "cartPage.report.approx.weight",
    "cartPage.report.timestamp",
    "cartPage.table.header.product.title",
    "cartPage.report.description",
    "cartPage.report.material.number.13.digit",
    "cartPage.report.material.number.15.digit",
    "cartPage.table.header.custId.title",
    "cartPage.table.header.packaging.title",
    "cartPage.table.header.quantity.title",
    "cartPage.table.header.packaging.subtitle",
    "cartPage.table.header.delivery.title",
    "cartPage.table.header.delivery.subtitle",
    "cartPage.table.header.availability.title",
    "cartPage.table.header.price.title",
    "cartPage.table.header.price.subtitle",
    "cartPage.table.header.total.title",
    "cartPage.report.comment",
    "cartPage.table.header.endCustomer.title",
    "cartPage.table.header.priceReference.title",
    "product.dts",
    "common.product.perMonth",
    "cartPage.report.reference",
    "order.report.header.customer.order.number",
  ];
};
